import { BIModel } from './BIModel';

export class UserReviewStartBIModel extends BIModel {

  static eventName = 'user_review_start';

  #sellerId;
  #productId;

  constructor(userId, sellerId, productId) {
    super(UserReviewStartBIModel.eventName, userId);
    this.#sellerId = sellerId;
    this.#productId = productId;
  }

  get sellerId() {
    return this.#sellerId;
  }

  get productId() {
    return this.#productId;
  }

  get modelData() {
    return {
      seller_id: this.sellerId,
      product_id: this.productId
    }
  }
  
}